<script setup>

import PopupModal from "@/components/shared/PopupSing.vue";
import StopSignInModal from "@/components/shared/Presence/StopSignInDialog.vue";
import PresenceService from "@/api/services/newPresencia.service";
import CommonService from "@/api/services/common.service";
import moment from "moment";
import Notification from '@/utils/plugins/NotificationService'
import { useAuthStore } from "@/app/stores/authStore";
import { usePresenceStore } from "@/app/stores/presenceStore";
import { computed, onMounted, onUnmounted, ref } from "vue";


const authStore = useAuthStore();
const presenceStore = usePresenceStore();
defineProps({
  title: {
    type: String,
    default: ""
  },
  showCard: {
    type: Boolean,
    default: false
  }
})

onMounted(() => {
  getServerTime();

})
onUnmounted(() => {
  stopWorker();
})
const now = ref('');
const showmodal = ref(false);
const waitingSignUp = ref(false);
const signings = ref([]);
const currentSign = ref([]);

const modalStopSignIn = ref(false);

// eslint-disable-next-line no-unused-vars
const user = computed(() => {
  return authStore.getUserLogged;
})
const isBeenClicked = ref(false);

const hoursWorked = computed(() => {
  return presenceStore.hoursWorked;
})
const hoursBreaked = computed(() => {
  return presenceStore.hoursBreaked;
})
const signButton = computed(() => presenceStore.sign_button);
const stopButton = computed(() => presenceStore.stop_button);
const formattedHoursWorked = computed(() => {
  return secondsToTime(hoursWorked.value);
})
const formattedHoursBreaked = computed(() => {
  return secondsToTime(hoursBreaked.value);
})

// eslint-disable-next-line no-unused-vars
const presenceWorker = ref(null);

const getServerTime = async () => {
  if (!user.value) return;
  const response = await CommonService.getServerTimestamp();
  if (!user.value || !response?.data?.serverTimestamp) return;
  now.value = moment(response.data.serverTimestamp, "YYYY-MM-DDTHH:mm:ss");

  await getPresenceData();
  if (window.Worker) {
    if (presenceWorker.value) {
      stopWorker();
    }
    presenceWorker.value = new Worker(
      new URL("@/worker/timeEntryWorker.js", import.meta.url),
      { type: "module" }
    );
    presenceWorker.value.onmessage = (event) => {
      if (event.data === "tick") {
        now.value = now.value.clone().add(1, 'seconds');
        presenceStore.calculateWorkedTime(now.value);
      }
    };
    presenceWorker.value.postMessage({ command: "start", interval: 1000 });
  }
}

const stopWorker = () => {
  if (presenceWorker.value && presenceWorker.value.postMessage) {
    presenceWorker.value.postMessage({ command: "stop" });
    presenceWorker.value.terminate();
  }
  presenceWorker.value = null;
}
const getPresenceData = async () => {
  if (!user.value) return;
  let from_date = moment(now.value);
  from_date.hour(0).minute(0).second(0);
  let to_date = moment(now.value);
  to_date.hour(23).minute(59).second(59);


  signings.value = [];
  currentSign.value = [];

  try {
    const response = await PresenceService.getWorkRecordsUser({
    "recordedAt[after]": from_date.format("YYYY-MM-DDTHH:mm:ss"),
    "recordedAt[before]": to_date.format("YYYY-MM-DDTHH:mm:ss"),
    itemsPerPage: 50,
    "order[recordedAt]": "ASC",
    });
    const records = response?.data?.['hydra:member'];
    if (records) {
      if (records.length % 2 === 0) {
        presenceStore.setSignButton(true);
      } else {
        presenceStore.setSignButton(false);
      }
      const newArray = [];
      for (let i = 0; i < records.length; i++) {
        const element = records[i];
        let newT = {};
        newT.time = moment(element.recordedAt).format('HHmmss');
        newT.type = element.type;
        if (element.pauseReason) newT.pauseReason = element.pauseReason;
        newArray.push(newT);
      }
      currentSign.value = newArray;
      await presenceStore.currentPresence(newArray);
      await presenceStore.calculateWorkedTime(now.value);
      await getWorkRecordStatus();
      if (isBeenClicked.value) {
        getNotification();
        isBeenClicked.value = false;
      }
      setTimeout(() => {
        waitingSignUp.value = false;
      }, 4000)
    }
  } catch {
    Notification.addNotification('Error al fichar', 'error', 6000)
    waitingSignUp.value = false;
  }
}

const getWorkRecordStatus = async () => {
  if (!user.value) return;
  const response = await PresenceService.getWorkRecordsStatus({});
  if (!response?.data) return;
  const status = response.data
  presenceStore.setStatusButtons(status)
}

const addSignUp = async () => {
  if (!user.value) return;
  if (waitingSignUp.value || !stopButton.value) return;
  //this.closeSignModal();
  waitingSignUp.value = true;
  isBeenClicked.value = true;

  await presenceStore.addSigning();
  await getServerTime();
}

const getNotification = () => {
  let mssg;
  if (signButton.value) {
    stopWorker();
    mssg = 'Presencia finalizada con éxito';
  } else {
    mssg = 'Presencia registrada con éxito';
  }
  Notification.addNotification({
    type: 'success',
    message: mssg,
    duration: 6000
  })
}

// eslint-disable-next-line no-unused-vars
const showSignModal = () => {
  showmodal.value = !showmodal.value;
  getServerTime();
}

// eslint-disable-next-line no-unused-vars
const closeSignModal = () => {
  showmodal.value = false
}

const secondsToTime = (s) => {
  const total = Number(s);
  if (!Number.isFinite(total) || total <= 0) return '';

  function addZ(n) {
    return (n < 10 ? '0' : '') + n;
  }

  let ms = total % 1000;
  s = (total - ms) / 1000;
  let secs = s % 60;
  s = (s - secs) / 60;
  let mins = s % 60;
  let hrs = (s - mins) / 60;

  if (!Number.isFinite(hrs) || !Number.isFinite(mins) || hrs < 0 || mins < 0) return '';

  return addZ(hrs) + 'h:' + addZ(mins) + 'm';
}
// eslint-disable-next-line no-unused-vars
const formatTimeStyle = (value) => {
  // console.log(value);
  if (value) {
    let hours = value.hours().toString().length === 1 ? '0' + value.hours().toString() : value.hours();
    let minutes = value.minutes().toString().length === 1 ? '0' + value.minutes().toString() : value.minutes();

    return hours + 'h:' + minutes + 'm';

  }
  return '';
}

const stopSignIn = async () => {
  if (waitingSignUp.value || signButton.value) return;
  waitingSignUp.value = true;
  if (stopButton.value) {
    openDialogModalStopSignIn();
  } else {
    await presenceStore.addStop();
    await getServerTime();
    Notification.addNotification({
      type: 'success',
      message: 'Presencia reanudada',
      duration: 6000
    })
  }
}

const confirmDialogModalStopSignIn = async (selectedReason) => {
  if (selectedReason) {
    // La parada ya se ha guardado en StopSignInDialog.
    await getServerTime();


  }
}

const openDialogModalStopSignIn = () => {
  modalStopSignIn.value = true;
}


</script>

<template>
  <div class="d-flex flex-nowrap shared-presence-wrapper">
    <div class="d-flex flex-nowrap all-text-presence">
      <div class="align-self-start">
        <svg id="chronometer-head" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 233.8 233.8">
          <path
            d="M188.2 79.4l6.1-6.1 2.9 2.9c1.5 1.5 3.4 2.2 5.3 2.2 1.9 0 3.8-0.7 5.3-2.2 2.9-2.9 2.9-7.7 0-10.6l-16.4-16.4c-2.9-2.9-7.7-2.9-10.6 0 -2.9 2.9-2.9 7.7 0 10.6l2.9 2.9 -6.1 6.1c-10.4-8.9-22.9-15.6-36.5-19.2 4.1-5.2 6.5-11.8 6.5-18.9C147.6 13.8 133.8 0 116.9 0c-16.9 0-30.7 13.8-30.7 30.7 0 7.1 2.4 13.7 6.5 18.9 -13.6 3.6-26 10.3-36.5 19.2l-6.1-6.1 2.9-2.9c2.9-2.9 2.9-7.7 0-10.6 -2.9-2.9-7.7-2.9-10.6 0L26 65.7c-2.9 2.9-2.9 7.7 0 10.6 1.5 1.5 3.4 2.2 5.3 2.2s3.8-0.7 5.3-2.2l2.9-2.9 6.1 6.1c-13.9 16.4-22.4 37.6-22.4 60.7 0 51.6 42 93.7 93.7 93.7s93.7-42 93.7-93.7C210.5 117 202.1 95.8 188.2 79.4zM101.2 30.7c0-8.7 7.1-15.7 15.7-15.7s15.7 7.1 15.7 15.7 -7.1 15.7-15.7 15.7S101.2 39.4 101.2 30.7zM116.9 218.8c-43.4 0-78.7-35.3-78.7-78.7 0-43.4 35.3-78.7 78.7-78.7 43.4 0 78.7 35.3 78.7 78.7C195.5 183.5 160.3 218.8 116.9 218.8z" />
          <path
            d="M116.9 77c-4.1 0-7.5 3.4-7.5 7.5v55.6c0 4.1 3.4 7.5 7.5 7.5 4.1 0 7.5-3.4 7.5-7.5V84.5C124.4 80.3 121 77 116.9 77z" />
        </svg>
      </div>
      <div class="d-flex flex-column align-self-start">
        <span class="text-presence">Presencia</span>
        <div class="presence-times d-flex align-items-center flex-wrap">
          <div class="presence-time-item d-flex align-items-center">
            <font-awesome-icon icon="briefcase" class="presence-time-icon" style="margin-top: 3px;"
              v-if="formattedHoursWorked" />
            <span class="secondsPresence">{{ formattedHoursWorked }}</span>
          </div>
          <div class="presence-time-item d-flex align-items-center">
            <font-awesome-icon icon="mug-hot" class="presence-time-icon presence-break-icon"
              v-if="formattedHoursBreaked" />
            <span class="secondsPresence">{{ formattedHoursBreaked }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center button-prsence">
      <button style="max-width: 150px" :class="signButton ? 'btn_yellow' : 'btn_red'"
        class="btn btn-block btn-action-presence ml-3" :disabled="waitingSignUp || !stopButton"
        @click="addSignUp()">
        {{
          signButton ? 'EMPEZAR' :
            'TERMINAR'
        }}
      </button>
      <button style="max-width: 150px" :class="stopButton ? 'btn_orange' : 'btn_lime'"
        class="btn btn-block btn-action-presence ml-3" :disabled="waitingSignUp || signButton"
        @click="stopSignIn()">
        {{
          stopButton ? 'PARAR' :
            'REANUDAR'
        }}
      </button>
    </div>
    <!-- <shared-modal
      v-if="showmodal"
      :title="'Fichaje desde Presencia'"
      :theme="'secondary'"
      :size="'small'"
      @close="closeSignModal()"
    >
      <template v-slot:content>
        <br />
        <div>
          <p>
            <font-awesome-icon icon="exclamation-triangle" />
            Confirma que estas fuera de la oficina
          </p>
          <div class="row item-modal">
            <div class="col-sm-6">
              <button
                class="btn btn-block btn_red"
                type="button"
                @click="closeSignModal()"
              >
                Cancelar
              </button>
            </div>
            <div class="col-sm-6">
              <button class="btn btn_blue" type="button" @click="addSignUp()">
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </template>
</shared-modal> -->
    <StopSignInModal v-model="modalStopSignIn" @confirm="confirmDialogModalStopSignIn" @close="waitingSignUp = false" />
    <PopupModal :is-show="showmodal" @accept="addSignUp()" />
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/sass/styles.scss";

#chronometer-head {
  fill: $yellow-color;
  width: 50px;
  margin-right: 5px;
  margin-top: 15px;
}

.text-presence {
  font-size: 3em;
  font-weight: 900;
  letter-spacing: -0.05em;
}

.btn-action-presence {
  width: 20em;
  height: 3em;
  font-weight: bold;
}

.button-prsence {
  margin-left: 15px;
}


h1 {
  text-align: left;
  font-size: 4em;
  font-weight: 900;
  letter-spacing: -0.05em;
}

.presence-times {
  margin-top: -8px;
}

.presence-time-item {
  margin-right: 18px;
}

.presence-time-icon {
  margin-right: 6px;
}


.btn-on {
  background-color: red;
}

.btn-off {
  background-color: green;
}

@media(min-width:501px) {
  .secondsPresence {
    font-size: 20px;
  }

  .presence-time-icon {
    width: 20px;
    height: 20px;
  }
}

@media(max-width:500px) {
  .btn-action-presence {
    font-size: 1em;
    width: 10em;
  }

  .text-presence {
    font-size: 20px;
  }

  .secondsPresence {
    font-size: 20px;
  }
}

@media(max-width:460px) {
  #chronometer-head {
    width: 20px;
  }

  .btn-action-presence {
    font-size: 0.8em;
    width: 8.5em;
  }

  .text-presence {
    font-size: 17px;
  }

  .secondsPresence {
    font-size: 17px;
  }
}

@media (max-width:450px) {
  .button-prsence {
    margin-left: 5px !important;
  }

  .all-text-presence {
    margin-left: -15px !important;
  }
}

@media(max-width:370px) {
  .btn-action-presence {
    font-size: 0.67em;
    width: 8.5em;
  }

  .text-presence {
    font-size: 15px !important;
  }

  .secondsPresence {
    font-size: 15px;
  }
}

@media(max-width:300px) {
  .btn-action-presence {
    font-size: 0.66em;
    width: 8em;
  }

  .text-presence {
    font-size: 12px !important;
  }

  .secondsPresence {
    font-size: 12px;
  }
}
</style>
